module.exports = __webpack_public_path__ + "assets/img/30_785_big.603dcc81.jpg";